import { render, staticRenderFns } from "./AddExtensionRepos.vue?vue&type=template&id=0c28a860&scoped=true&"
import script from "./AddExtensionRepos.vue?vue&type=script&lang=js&"
export * from "./AddExtensionRepos.vue?vue&type=script&lang=js&"
import style0 from "./AddExtensionRepos.vue?vue&type=style&index=0&id=0c28a860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c28a860",
  null
  
)

export default component.exports